module.exports = __webpack_public_path__ + "img/icon-english.b52f6240.svg";